import { Fragment } from 'react';

/** One stretch of copy, emphasized or not, so a sentence held in constants can carry emphasis without JSX. */
export interface TextSegment {
  text: string;
  bold?: boolean;
}

/** Renders a sentence stored as segments, wrapping the emphasized ones in `<strong>`. */
function EmphasizedText({ segments }: { segments: readonly TextSegment[] }) {
  return segments.map((segment, index) => (
    // biome-ignore lint/suspicious/noArrayIndexKey: segments are static copy and repeat text, so position is the only stable key
    <Fragment key={index}>{segment.bold ? <strong>{segment.text}</strong> : segment.text}</Fragment>
  ));
}

export { EmphasizedText };
